import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../utils/api';
//import { getPermissionByUserNameOrRole } from '../services/Administracion/permissionService';
import { useAuth, UserType } from '../context/AuthContext';



const Login: React.FC = () => {
    //const [username, setUsername] = useState<string>('gerardo.najera@grupociisa.com')
    const [username, setUsername] = useState<string>('')
    const [password, setPassword] = useState<string>('')
    const [error, setError] = useState<string>('')
    const navigate = useNavigate();
    const { login: authenticateUser } = useAuth();
    const [showPassword, setShowPassword] = useState<boolean>(false);

    const userAgent = navigator.userAgent.toLowerCase();

    //console.log('Rosa María Rodríguez Rodríguez' ,('Rosa María Rodríguez Rodríguez').length);


    const handleBlur = () => {
        if (!username.includes('@')) {
            setUsername(`${username}@grupociisa.com`);
        }
    }

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            //valida el usuario contra el API que valida contra el AD
            const { data } = await login({ username, password });

            const user: UserType = {
                User: {
                    name: data.user.name,
                    position: data.user.position,
                    email: data.user.email,
                    role: data.user.role,
                    //permissions: data.user.permissions || []
                },
                //role: 'admin',
                token: data.token,
                permissions: data.user.permissions || [] // Asignar permisos del usuario
            };


            authenticateUser(user);

            // const permissions = await getPermissionByUserNameOrRole(data.user.email, data.user.role);
            // console.log('Permisos obtenidos: ', permissions);

            // user.permissions = permissions || [];
            // authenticateUser(user);


            //localStorage.setItem('token', data.token);
            console.log('Role del usuario en login: ', user.User.role);
            if (user.User.role === "Pistero") {
                navigate('/captura-combustible');
            } if (user.User.role === "Administrativos") {
                navigate('/panel-supervisor-visitas');
            }
            else {
                navigate('/dashboard');
            }

        } catch (error: any) {
            setError(`Credenciales incorrectas. Inténtalo de nuevo. ${error.message}`);
        }
    };

    const DeviceIndicator = () => {
        const [deviceInfo, setDeviceInfo] = useState({ type: '', icon: '', color: '' });

        React.useEffect(() => {
            const ua = navigator.userAgent.toLowerCase();
            if (ua.includes('zebra') || ua.includes('tc26') || ua.includes('tc21')) {
                setDeviceInfo({
                    type: 'HH ZEBRA',
                    icon: 'fa-mobile-alt',
                    color: 'warning'
                });
            } else if (ua.includes('windows')) {
                setDeviceInfo({
                    type: 'WINDOWS',
                    icon: 'fa-windows',
                    color: 'info'
                });
            } else {
                setDeviceInfo({
                    type: navigator.platform,
                    icon: 'fa-question-circle',
                    color: 'secondary'
                });
            }
        }, []);

        return (
            <div
                className={`position-fixed top-0 end-0 m-2 badge bg-${deviceInfo.color} p-2 shadow-sm`}
                style={{ zIndex: 1050, opacity: 0.8, fontSize: '0.75rem' }}
                title={`Dispositivo: ${deviceInfo.type}`}
            >
                <i className={`fas ${deviceInfo.icon} me-1`}></i>
                {deviceInfo.type}
            </div>
        );
    };

    return (
        <div className="container d-flex flex-column align-items-center justify-content-center vh-100">
            <DeviceIndicator />
            <div className='card p-4 shadow' style={{ maxWidth: '500px', width: '100%' }}>
                <img src={require('../assets/CiisaLogo.png')} alt='logo' className='img-fluid mb-3' style={{ height: '50px', width: '100%', objectFit: 'contain' }} />
                <h1 className='mb-4 text-center' >Iniciar Sesión</h1>
                {/* <small className='text-center'>Dispositvo: {userAgent.toLowerCase().includes('windows') ? 'Windows' : userAgent.toLowerCase().includes('zebra') ? 'Hand Held' : ''}</small> */}
                {error && (
                    <div className="alert alert-danger alert-dismissible fade show text-center" role="alert">
                        {error}
                        <button
                            type="button"
                            className="btn-close"
                            aria-label="Close"
                            onClick={() => setError('')}
                        ></button>
                    </div>
                )}
                <form onSubmit={handleSubmit}>
                    <div className='mb-3' >
                        <input style={{ width: '100%', borderRadius: '5px', border: '1px solid #ccc', padding: '10px' }}
                            type={"text"}
                            placeholder="Ingrese su Usuario"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            onBlur={handleBlur}
                            required
                        />

                    </div>
                    <div className='mb-3 position-relative'>
                        <input style={{ width: '100%', borderRadius: '5px', border: '1px solid #ccc', padding: '10px', paddingRight: '40px' }}
                            type={showPassword ? "text" : "password"}
                            placeholder="Contraseña"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                        <button
                            type="button"
                            className="btn btn-light position-absolute"
                            style={{ right: '10px', top: '50%', transform: 'translateY(-50%)', padding: '5px' }}
                            onClick={() => setShowPassword(!showPassword)}
                        >
                            <i className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"}`} />
                        </button>
                    </div>
                    <button className='btn btn-primary w-100' type="submit">Iniciar Sesión</button>
                </form>
            </div>
        </div>
    );
};

export default Login;


